// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","headline":"_2VZ8OfV6pCjbZciF18Vn1A","caption2":"_3FCgXshmQfWC83mTTDn6Lf","title":"AJZRYyONObDPYEhLOvwo9 _2VZ8OfV6pCjbZciF18Vn1A","subtitle":"WFy5tIupBkovp47nRVVtc _3FCgXshmQfWC83mTTDn6Lf"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/shipping-options/shipping-section/ShippingSection.css
// module id = 802
// module chunks = 0